import React from 'react';
import ConfiguratorOption from '../ConfiguratorOption';
import Carport from '../../images/1/reactcode/Carport';
import Terassen from '../../images/1/reactcode/Terassen';
import Wntergarten from '../../images/1/reactcode/Wntergarten';

interface ProductSelectionProps {
  selectedProduct: string;
  onSelectProduct: (product: string) => void;
}

const ProductSelection: React.FC<ProductSelectionProps> = ({ selectedProduct, onSelectProduct }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-2 gap-x-2 gap-y-2 w-full">
      <ConfiguratorOption
        label="Terrassenüberdachung"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/v1/terra.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/Carport.svg`}
        onClick={() => onSelectProduct("Terrassenüberdachung")}
        isSelected={selectedProduct === "Terrassenüberdachung"}
        SVGComponent={Terassen}
      />
      {/* <SVGComponent /> */}
      <ConfiguratorOption
        label="Carport"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/v1/Carport.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/Carport.svg`}
        onClick={() => onSelectProduct("Carport")}
        isSelected={selectedProduct === "Carport"}
        SVGComponent={Carport}
      />
      <ConfiguratorOption
        label="Wintergarten"
        imageMobile={`${process.env.REACT_APP_PUBLIC_URL}/images/mobile/v1/Wintergarten.svg`}
        imageDesktop={`${process.env.REACT_APP_PUBLIC_URL}/images/desktop/Carport.svg`}
        onClick={() => onSelectProduct("Wintergarten")}
        isSelected={selectedProduct === "Wintergarten"}
        SVGComponent={Wntergarten}
      />
    </div>
  );
};

export default ProductSelection;
